/**
 * Child Theme - Scripts
 * File: custom-javascript.js
 * Description: file Js principale para el tema Child, qui vengono inizializzati i moduli js.
 *
 */

import StickyNavbar from "./modules/sticky-navbar.js";
import { initPrimoPianoSlider } from "./modules/primo-piano-slider.js";

jQuery(document).ready(function ($) {
  console.log("Theme Child ASSOCOOP → DOM pronto 👍");

  // Inizializza la Navbar sticky
  StickyNavbar.initialize("mainNavbar");

  // Inizializza lo slider PrimoPiano, attivato solo se necessario
  initPrimoPianoSlider();
});
